module.exports = __webpack_public_path__ + "img/item2.ca2bce33.png";